import { render, staticRenderFns } from "./_launchWbet.vue?vue&type=template&id=38864ac0&lang=pug&"
import script from "./_launchWbet.vue?vue&type=script&lang=js&"
export * from "./_launchWbet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports